function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M22.261 107.592h467.478v296.815H22.261z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M370.111 404.4h119.628v-70.263L256 263.873l55.983 91.477zm119.628-237.383L256 263.873h233.739zM320.76 107.589L256 263.873l156.284-156.284zm-129.52 0L256 263.873V107.589zm-168.979 0v59.428L256 263.873 99.715 107.589zm0 156.284v70.263L256 263.873z",
  fill: "#0052b4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M258.469 266.281l48.717 33.919c8.681-12.468 12.605-28.247 9.716-44.383-5.779-32.272-36.625-53.748-68.896-47.969-32.272 5.779-53.748 36.625-47.969 68.896 2.889 16.136 12.045 29.572 24.514 38.253l33.918-48.716z",
  fill: "#ffda44"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M492.208 404.299H24.73l233.739-138.018z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M281.971 351.718c0 14.344-11.628 18.551-25.971 18.551s-25.971-4.207-25.971-18.551 11.628-25.971 25.971-25.971c14.343.001 25.971 11.628 25.971 25.971z",
  fill: "#ffda44"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M281.971 351.718c0 14.344-11.628 25.971-25.971 25.971s-25.971-11.628-25.971-25.971",
  fill: "#0052b4"
});

const SvgTibet = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTibet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tibet.9713e735.svg";
export { ForwardRef as ReactComponent };